@for (subArea of facet.metricTree.subAreas; track subArea) {
  <div class="hub-facet-filter">
    <h6>{{subArea.name}}</h6>
    @for (metric of subArea.metrics; track metric) {
      <div class="hub-facet-filter-content">
        <div>
          <mat-checkbox [(ngModel)]="metric.isChecked" color="primary"
            [disabled]="getNumberOfHits(subArea, metric) === 0"
            (change)="userChangedMetricSelection(subArea, metric)">
          </mat-checkbox>
        </div>
        <div class="filter-title">
          {{metric.name}}&nbsp;<span class="hub-number-of-hits">{{getNumberOfHits(subArea, metric) | number}}</span>
        </div>
      </div>
    }
  </div>
}
